import axiosInstance from "../config/axiosConfig";

const CourseService = {
  getCourses: async ({ signal } = {}) => {
    try {
      const response = await axiosInstance.get("/courses", { signal });
      if (!Array.isArray(response.data)) {
        throw new Error("La réponse du serveur ne contient pas une liste de cours valide.");
      }
      return response.data;
    } catch (error) {
      if (error.code !== "ERR_CANCELED") {
        console.error("Error fetching courses:", error);
      }
      throw error;
    }
  },

  getCourse: async (courseId, { signal } = {}) => {
    try {
      const response = await axiosInstance.get(`/courses/${encodeURIComponent(courseId)}`, { signal });
      return response.data;
    } catch (error) {
      if (error.code !== "ERR_CANCELED") console.error("Error fetching course:", error);
      throw error;
    }
  },

  addCourse: async (courseData) => {
    try {
      const response = await axiosInstance.post("/courses", courseData);
      return response.data;
    } catch (error) {
      if (error.code !== "ERR_CANCELED") {
        console.error("Error adding course:", error);
      }
      throw error;
    }
  },

  ressourcesTypes: async ({ signal } = {}) => {
    try {
      const response = await axiosInstance.get("/resource-types", { signal });
      return response.data;
    } catch (error) {
      if (error.code !== "ERR_CANCELED") {
        console.error("Error fetching resource types:", error);
      }
      throw error;
    }
  },

  addResource: async (resourceData) => {
    try {
      const response = await axiosInstance.post("/resources", resourceData);
      return response.data;
    } catch (error) {
      if (error.code !== "ERR_CANCELED") {
        console.error("Error adding resource:", error);
      }
      throw error;
    }
  },

  listCoursesByAcademicLevel: async (academicLevelId, { signal } = {}) => {
    try {
      const response = await axiosInstance.get(`/academic-levels/${encodeURIComponent(academicLevelId)}/courses`, { signal });
      return response.data;
    } catch (error) {
      if (error.code !== "ERR_CANCELED") {
        console.error("Error fetching courses by academic level:", error);
      }
      throw error;
    }
  },

  getResourcesByCourse: async (courseId, { signal } = {}) => {
    try {
      const response = await axiosInstance.get(`/courses/${encodeURIComponent(courseId)}/resources`, { signal });
      return response.data;
    } catch (error) {
      if (error.code !== "ERR_CANCELED") {
        console.error("Error fetching resources by course:", error);
      }
      throw error;
    }
  },

  updateResource: async (resourceId, resourceData) => {
    try {
      const response = await axiosInstance.post(`/resources/${encodeURIComponent(resourceId)}`, resourceData);
      return response.data;
    } catch (error) {
      if (error.code !== "ERR_CANCELED") {
        console.error("Error updating resource:", error);
      }
      throw error;
    }
  },

  deleteResource: async (resourceId) => {
    try {
      const response = await axiosInstance.delete(`/resources/${encodeURIComponent(resourceId)}`);
      return response.data;
    } catch (error) {
      if (error.code !== "ERR_CANCELED") {
        console.error("Error deleting resource:", error);
      }
      throw error;
    }
  },

};

export default CourseService;
